// src/services/shiftsService.js
import { apiRequest } from './api';

export const shiftsService = {
    // Get shifts list
    getShifts: async (params = {}) => {
        try {
            const response = await apiRequest.get('/shifts', { params });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch shifts');
        }
    },

    // Get single shift details
    getShiftById: async (shiftId) => {
        try {
            const response = await apiRequest.get(`/shifts/${shiftId}`);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch shift details');
        }
    },

    // Create new shift
    createShift: async (shiftData) => {
        try {
            const response = await apiRequest.post('/shifts', shiftData);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to create shift');
        }
    },

    // Update shift
    updateShift: async (shiftId, shiftData) => {
        try {
            const response = await apiRequest.put(`/shifts/${shiftId}`, shiftData);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to update shift');
        }
    },

    // Delete shift
    deleteShift: async (shiftId) => {
        try {
            const response = await apiRequest.delete(`/shifts/${shiftId}`);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to delete shift');
        }
    },

    // Assign single staff to shift
    assignStaffToShift: async (assignmentData) => {
        try {
            const response = await apiRequest.post('/shift-assignments', assignmentData);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to assign staff to shift');
        }
    },

    // Bulk assign staff to shift via CSV
    bulkAssignStaffToShift: async (formData) => {
        try {
            const response = await apiRequest.post('/shift-assignments/bulk', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to bulk assign staff');
        }
    },

    // Get staff shift assignments
    getStaffShifts: async (params = {}) => {
        try {
            const response = await apiRequest.get('/shift-assignments', { params });
            return response.data.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to fetch staff shift assignments');
        }
    },

    // Remove staff from shift
    removeStaffFromShift: async (assignmentId) => {
        try {
            const response = await apiRequest.delete(`/shift-assignments/${assignmentId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to remove staff from shift');
        }
    },

    // Full shift assignment history for one staff member (every past and current assignment)
    getStaffShiftHistory: async (staffId) => {
        try {
            const response = await apiRequest.get('/shift-assignments/history', { params: { staff_id: staffId } });
            return response.data.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to fetch shift history');
        }
    },

    // Shift assignment history across all staff (for the "Shift History" tab)
    getAllShiftHistory: async (params = {}) => {
        try {
            const response = await apiRequest.get('/shift-assignments/all-history', { params });
            return response.data.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to fetch shift history');
        }
    }
};